module.exports = __webpack_public_path__ + "img/senalando-izqgt.png.b2ff9a13.webp";